import { SingleValueRxEmitter } from '@ocodelib/ex-util';

export const UnlockAudioEvent = new SingleValueRxEmitter(false);
